exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._10udy {\n  display: inline-block;\n  background: #fff;\n  color: #A89A72;\n  text-align: center;\n  cursor: pointer;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 5px;\n  border-right: 1px solid #A89A72;\n  text-transform: capitalize;\n}\n._10udy:last-child {\n  border-right: 0;\n}\n._10udy._3e2CF {\n  background: #A89A72;\n  color: #fff;\n  cursor: default;\n}\n", ""]);

// Exports
exports.locals = {
	"tab": "_10udy",
	"active": "_3e2CF"
};